import {
  MARKET_MODES,
  MARKET_MODE_STATUS,
  Market,
} from '../market';

const REVIEW_PRICE = 250;
const WARRANTY_HOURS = 168;
const CHAIN_ACTION_PRICE = 3.5;

const CHAINS_FAQ = [
  {
    title: 'Что такое поведенческий сценарий?',
    isH3: true,
    text:
      <p>
        Это последовательность действий, которые может выполнить пользователь на доске объявлений:
        <br />
        поиск по ключевым словам, просмотр фотографий, чтение описания, добавление в избранное, переход в профиль, чтение отзывов и другие действия. Такие сценарии позволяют оценивать насколько легко найти ваше объявление, помочь аудитории лучше взаимодействовать с товаром или услугой и проводить маркетинговые эксперименты.
      </p>
  },
  {
    title: 'Зачем это может быть полезно?',
    isH3: true,
    text:
      <p>
        Некоторые доски объявлений учитывают активность пользователей при формировании выдачи.
        <br /> 
        Поведенческие сценарии могут использоваться для анализа реакции на размещенный контент и тестирования гипотез о влиянии различных факторов: текста, оформления, ключевых фраз и т.п.
      </p>
  },
  {
    title: 'Boostclick — что это за сервис?',
    isH3: true,
    text:
      <p>
        Сервис предоставляет техническую платформу для размещения заданий, связанных с исследованием интереса пользователей к контенту на досках объявлений. 
        <br />
        <br />
        Задания выполняются третьими лицами — исполнителями, которые получают инструкции и оставляют отчеты по факту выполнения.
        <br />
        Boostclick не оказывает рекламных услуг, не гарантирует позиционирование объявлений и не вмешивается в работу внешних площадок.
      </p>
  },
  {
    title: 'Как подбирать ключевые фразы?',
    isH3: true,
    text:
      <div>
        Рекомендуем использовать открытые инструменты:
        <br />
        <br />
        <ul>
          <li><a href='https://wordstat.yandex.ru'>wordstat.yandex.ru</a></li>
          <li>Анализ объявлений конкурентов</li>
          <li>Подсказки при вводе запроса на самой площадке</li>
        </ul>
      </div>
  },
  {
    title: 'Кто выполняет сценарии?',
    isH3: true,
    text:
      <p>
        Сценарии выполняют сторонние исполнители, получившие задание через API. Они действуют по заданным параметрам, соблюдая инструкции, сформулированные заказчиком.
      </p>
  },
  {
    title: 'Как оформить объявление?',
    isH3: false,
    text:
      <div>
        Корректное оформление объявления — зона ответственности клиента. Рекомендуется:
        <br />
        <br />
        <ul>
          <li>Использовать точный заголовок</li>
          <li>Упоминать ключевые характеристики товара</li>
          <li>Структурировать описание</li>
          <li>Добавлять призыв к действию</li>
          <li>Проверять читаемость и уместность ключевых слов</li>
        </ul>
      </div>
  },
  {
    title: 'Когда можно увидеть результат?',
    isH3: true,
    text:
      <div>
        Сценарии исполняются в указанные сроки. Все действия фиксируются в отчетах. 
        <br />
        <br />
        Поскольку взаимодействие с объявлениями зависит от множества внешних факторов (категория, контент, конкуренция), Boostclick не оценивает и не гарантирует влияние активности на рейтинг, охваты или продажи.
      </div>
  },
  {
    title: 'Как оплатить?',
    isH3: true,
    text:
      <p>
        Оплата осуществляется через надежные платежные решения, включая Робокассу и безналичный расчет на основании оферты.
      </p>
  },
  {
    title: 'Почему я могу не видеть свое объявление?',
    isH3: false,
    text:
      <ul>
        Причины могут быть разными:
        <br />
        <br />
        <li>Изменились алгоритмы площадки</li>
        <li>Объявление было скрыто/удалено самой площадкой</li>
        <li>Выбрана категория или ключевые слова с низкой видимостью</li>
        <li>Объявление находится на глубокой позиции (например, за пределами 100-й строки)</li>
        <li>Прошло недостаточно времени для обновления индексации</li>
      </ul>
  },
  {
    title: 'За что сервис не несет ответственности?',
    isH3: false,
    text:
      <div>
        Boostclick не гарантирует и не оценивает:
        <br />
        <br />
        <ol>
          <li>Итоговые позиции объявления</li>
          <li>Количество просмотров или кликов</li>
          <li>Конверсию в продажи или заявки</li>
          <li>Эффективность выбранной стратегии</li>
          <li>Реакцию пользователей на контент</li>
        </ol>
        <br />
        <br />
        Сервис ограничивается предоставлением платформы для организации взаимодействий по заданным сценариям.
      </div>
  },
];

export const REVIEWS_FAQ = [
  {
    title: 'Что такое Boostclick и как это работает?',
    isH3: true,
    text:
      <p>
        Boostclick — это платформа, через которую можно разместить задание на удаленное тестирование карточек объявлений. 
        <br />
        <br />
        Тестировщики (третьи лица) изучают содержание, совершают определенные действия и могут оставить отзыв на основе собственного опыта взаимодействия.
      </p>
  },
  {
    title: 'Это «накрутка отзывов»?',
    isH3: true,
    text:
      <p>
        Нет. 
        <br />
        <br />
        Мы не пишем отзывы, не гарантируем их публикацию и не вмешиваемся в текст. 
        <br />
        Задания направлены на тестирование карточек, а отзывы — это возможный результат личного взаимодействия исполнителя. 
        <br />
        Упоминание “накрутка отзывов” используется на сайте только для SEO и ориентировано на тех, кто ищет легальные альтернативы.
      </p>
  },
  {
    title: 'Отзывы пишутся автоматически?',
    isH3: false,
    text:
      <p>
        Нет. 
        <br />
        <br />
        Каждый отзыв — это личное мнение исполнителя, основанное на удаленном взаимодействии с карточкой.
        <br />
        Мы не используем шаблоны, не подменяем контент и не влияем на оценку.
      </p>
  },
  {
    title: 'Можно ли просить только хорошие отзывы?',
    isH3: false,
    text:
      <p>
        Нет.
        <br />
        <br />
        Ни платформа, ни заказчик не могут требовать конкретную оценку. 
        <br />
        Исполнитель делится тем, что действительно почувствовал и заметил.
        <br />
        Это может быть как положительный, так и нейтральный или сдержанный отзыв.
      </p>
  },
  {
    title: 'Какие действия совершает исполнитель?',
    isH3: true,
    text:
      <ul>
        <li>Переходит по ссылке на карточку.</li>
        <li>Выполняет сценарий взаимодействия (например, открывает фото, читает описание, изучает условия).</li>
        <li>Формирует свое мнение о товаре/услуге.</li>
        <li>Если задание этого требует, пишет отзыв — на основе удаленного взаимодействия.</li>
      </ul>
  },
  {
    title: 'Что можно проверить удаленно?',
    isH3: false,
    text:
      <div>
        <ul>
          Исполнитель может оценить:
          <br />
          <br />
          <li>Бесплатные услуги и оченить качество консультации на основе которых сделать вывод и указать это в отзыве</li>
          <li>Структуру и оформление карточки;</li>
          <li>Информативность описания;</li>
          <li>Удобство восприятия контента;</li>
          <li>Визуальные материалы;</li>
          <li>Оформление и логику предложения.</li>
        </ul>
        <br />
        <br />
        <ul>
          Отзывы не могут включать:
          <br />
          <br />
          <li>Утверждения о покупке, если ее не было;</li>
          <li>Вводящие в заблуждение формулировки;</li>
          <li>Ложные заявления от имени клиента.</li>
        </ul>
      </div>
  },
  {
    title: 'Гарантируется ли публикация и рейтинг?',
    isH3: false,
    text:
      <div>
        Нет. 
        <br />
        Мы не контролируем модерацию сторонних сайтов и не гарантируем оценку «5 звезд».
        <br />
        <br />
        <ul>
          Результат зависит от:
          <br />
          <br />
          <li>качества карточки;</li>
          <li>полноты и честности задания;</li>
          <li>реакции и мнения исполнителя;</li>
          <li>правил платформы, где публикуется отзыв.</li>
        </ul>
      </div>
  },
  {
    title: 'Сколько стоят такие задания?',
    isH3: false,
    text:
      <p>
        В среднем:
        <br />
        <br />
        Удаленное тестирование с возможным отзывом — от 450 рублей.
        <br />
        Цена влияет на интерес исполнителей и качество их работы.
      </p>
  },
  {
    title: 'Кто такие исполнители?',
    isH3: false,
    text:
      <p>
        Это пользователи, прошедшие регистрацию на сторонней платформе, получающие задания через интеграцию (API).
        <br />
        Они самостоятельно решают, участвовать или нет, и пишут только о своем опыте.
      </p>
  },
  {
    noindex: true,
    title: 'Как выбрать надежного исполнителя?',
    isH3: false,
    text:
      <ul>
        <li>Ориентируйтесь на простоту и понятность задания.</li>
        <li>Указывайте реалистичные цели — не просите «5 звезд» или «продать товар».</li>
        <li>Уточняйте, что отзыв пишется только после фактического взаимодействия.</li>
      </ul>
  },
  {
    noindex: true,
    title: 'Что делать, если отзыв не появился?',
    isH3: false,
    text:
      <div>
        <ul>
          <li>Проверьте корректность ТЗ и ссылки.</li>
          <li>Убедитесь, что задание не нарушало правила платформы.</li>
          <li>Свяжитесь с поддержкой, если прошло более 6 рабочих дней.</li>
        </ul>
        <br />
        <b>Важно:</b> Boostclick не оказывает услуг написания отзывов, не продает и не гарантирует накрутку.
        <br />
        <br />
        Мы — технологическая платформа, позволяющая размещать задания для удаленного тестирования карточек, результаты которого могут включать личные мнения исполнителей.
        Все действия соответствуют нормам пользовательского взаимодействия и не нарушают публичные правила.
      </div>
  },
];

const VIEWS_FAQ = [
  {
    title: 'Зачем запускать просмотры от пользователей на досках объявлений?',
    isH3: true,
    text:
      <p>
        Просмотры от реальных пользователей в рамках UX-исследований помогают понять, как работает ваша карточка: привлекает ли она внимание, достаточно ли информативна, вызывает ли интерес. Эти данные могут быть использованы для улучшения объявления и повышения эффективности.
      </p>
  },
  {
    title: 'Кто выполняет просмотры?',
    isH3: true,
    text:
      <p>
        Просмотры выполняются третьими лицами, участвующими в UX-тестировании через платформу Boostclick.
        <br />
        <br />
        Это не сотрудники сервиса, а независимые участники, которые добровольно выполняют задания за вознаграждение.
      </p>
  },
  {
    title: 'Мы используем ботов?',
    isH3: true,
    text:
      <p>
        Нет.
        <br />
        <br />
        Задания публикуются только для реальных людей. Участники подтверждают факт просмотра через ответы на вопросы, связанные с содержанием объявления. Это исключает автоматические скрипты и делает процесс максимально естественным.
      </p>
  },
  {
    title: 'Это влияет на позицию объявления?',
    isH3: false,
    text:
      <p>
        Boostclick не может гарантировать влияние на рейтинг или видимость.
        <br />
        Любые изменения могут быть результатом самого контента карточки, выводов заказчика и его последующих действий.
        <br />
        Платформа не оказывает влияния на алгоритмы площадки и не участвует в продвижении.
    </p>
  },
  {
    title: 'Как обеспечивается качество взаимодействия?',
    isH3: false,
    text:
      <p>
        Каждое задание содержит контрольные вопросы или действия, которые требуют осознанного взаимодействия с карточкой.
        <br />
        Это может быть поиск конкретной информации, просмотр фотографий или указание параметров.
        <br />
        Так можно убедиться, что задание выполнено вручную.
    </p>
  },
  {
    title: 'Когда появляются первые просмотры?',
    isH3: false,
    text:
      <p>
        Как правило, пользователи начинают выполнять задания в течение 1–6 часов после запуска. Однако платформа не управляет скоростью или результатами исполнения — все зависит от интереса и активности третьих лиц.
    </p>
  },
  {
    title: 'Сколько стоит запуск задания?',
    isH3: true,
    text:
      <p>
        Вы сами определяете условия задачи и вознаграждение.
        <br />
        Обычно просмотр + целевое действие оцениваются в 4 рубля (2 рубля за просмотр + 2 рубля за выполнение действия).
        <br />
        Стоимость может быть выше в зависимости от сложности и требований.
      </p>
  },
];

const AVITO_PF_ARTICLE = {
  title: 'Поведенческие факторы на объявлениях в 2026 году: как алгоритмы видят интерес пользователей',
  content: <div>
    В 2026 году механизмы ранжирования объявлений на крупных платформах стали гораздо сложнее, чем несколько лет назад. Если раньше приоритет отдавался свежести и цене, то сегодня всё строится вокруг поведенческих факторов (ПФ) — совокупности действий пользователей, которые помогают алгоритмам определить, насколько конкретное объявление действительно интересно аудитории.
    <br />
    <br />
    <h3>Что такое поведенческие факторы и зачем они нужны</h3>
    <br />
    <ul>
      Поведенческие факторы — это данные о поведении реальных пользователей:
      <li>сколько времени они проводят на странице объявления;</li>
      <li>как часто переходят по ссылкам или пишут продавцу;</li>
      <li>возвращаются ли к тому же объявлению после поиска;</li>
      <li>делятся ли им, сохраняют ли его в избранное;</li>
      <li>какова частота взаимодействий (просмотр → контакт → сделка).</li>
    </ul>
    <br />
    На основе этих метрик система машинного обучения делает вывод о том, насколько объявление релевантно и полезно, и, как следствие, повышает его позицию в поиске.
    <br />
    <br />
    <h3>Как формируется поиск объявлений</h3>
    <br />
    Алгоритмы поиска стремятся не просто выдать подходящие результаты, а упорядочить их так, чтобы пользователю было удобно выбирать. Система анализирует сотни параметров: от точности заполнения категорий и региона до привлекательности фотографий и рейтинга продавца.
    <br />
    <br />
    <ul>
      Ранжирование происходит среди активных объявлений и зависит от:
      <li>релевантности запросу (заголовок, описание, ключевые параметры);</li>
      <li>актуальности (дата размещения, статус активности);</li>
      <li>качества информации (наличие фото, точность описания, честность);</li>
      <li>оценки сервиса продавца (рейтинг, отзывы, скорость ответов);</li>
      <li>уровня доверия (верификация профиля, история взаимодействий).</li>
    </ul>
    <br />
    <h3>Что изменилось в 2026 году</h3>
    <br />
    Главное новшество — усиление роли ПФ и машинного обучения. Платформы больше не полагаются на «жёсткие» фильтры, а строят динамические прогнозы интереса.
    <br />
    <br />
    <ul>
      Теперь учитываются такие параметры, как:
      <li>скорость реакции пользователя на объявление после выдачи;</li>
      <li>мультисессия (повторные визиты, цепочки просмотров);</li>
      <li>глубина взаимодействия — насколько далеко человек продвинулся воронке (например, просмотр → чат → сделка);</li>
      <li>контекст устройства и региона (гео, тип девайса, даже время суток).</li>
    </ul>
    <br />
    Эти данные позволяют алгоритмам индивидуализировать выдачу: два разных человека, задав одинаковый запрос, увидят разные объявления, оптимизированные под их личные интересы.
    <br />
    <br />
    <ul>
      Как правильно подходить к оптимизации ПФ
      <li>Фокус на пользователе, а не на системе. Алгоритмы отслеживают не «накрутку», а реальное вовлечение.</li>
      <li>Максимум достоверности. Чем меньше несоответствий (в тексте, фото, цене), тем выше доверие.</li>
      <li>Сценарии поведения. Продающие тексты должны вызывать естественные клики и длительное внимание.</li>
      <li>Вовлечение после просмотра. Добавляйте кнопки, контактные элементы, уточняющие детали — чтобы пользователь действовал.</li>
      <li>Анализ данных. Сервисы мониторинга позволяют видеть глубину просмотров, CTR, конверсию — и адаптировать объявления под реальное поведение аудитории.</li>
    </ul>
    <br />
    <h3>Почему важно соблюдать баланс</h3>
    <br />
    Платформы усилили контроль за искусственными методами стимулирования активности. Но оптимизация под ПФ — не нарушение, если она направлена на улучшение пользовательского опыта. Например, изменение описания, улучшение фото, добавление ответов на частые вопросы — это формы поведенческого тестирования, а не манипуляции.
    <br />
    <br />
    В 2026 году компании, которые работают с поведением пользователей через исследования и UX-оптимизацию, получают гораздо лучшие позиции без риска санкций.
    <br />
    <br />
    <h3>Вывод</h3>
    <br />
    Поведенческие факторы стали ключевым элементом успеха для любого онлайн-продавца. В 2026 году платформа видит не только цену и заголовок, но и то, как аудитория реагирует. Главный принцип: чем больше реальной пользы получает человек, тем выше поднимается объявление в поиске.
  </div>
};

const STEP_TWO_TITLE_FAQ = <p>
  Почему при добавлении одного действия в калькуляторе появляются дополнительные действия?
  <br />
  <br />
  Сервис формирует уникальные сценарии для каждого исполнителя, и каждый сценарий начинается для нового исполнителя с поиска объявления по сделанному скриншоту вашей ссылки.
  <br />
  <br />
  Например, если вы заказали «Добавить в избранное», то сервис автоматически создаст новый сценарий, начиная с «Открыть сайт или приложение» - «Найти по фразе» - «Посмотреть конкурентов» и т.д.
  <br />
  <br />
  Исключение «Просмотры». Там мы даем не прямую ссылку, чтобы удешевить задание.
</p>;

const VIEW_SUBACTIONS_COMMENT = <p>
  Мы добавили дополнительные задания для исполнителей, чтобы они тратили больше времени на просмотр карточек и проявляли реальный интерес, а не просто кликали.
  <br />
  <br />
  Такие просмотры от реальных пользователей не считаются отказом (некачественными) на досках объявлений, а контрольные вопросы помогут вам убедиться, что задания действительно выполнены.
</p>;

const ACTIONS = [
  {
    type: 'MAIN.REVIEW',
    icon: "message",
    iconHome: "home-message",
    title: 'Написать отзыв о бесплатной услуге',
    titleComment: '(полное тестирование вашей услуги)',
    initialShare: 1,
    price: `от ${REVIEW_PRICE}`,
    itemTitle: 'тест+отзыв',
    activityType: 'Отзыв', // NOTE: do not change (see PopupStore.js abd ReportModal.jsx)
  },

  {
    type: 'MAIN.LIKE',
    icon: "heart",
    iconHome: "home-star",
    title: 'Добавить объявление в избранное',
    initialShare: 0.3,
    activityType: 'Избранное',
    price: CHAIN_ACTION_PRICE,
  },
  {
    type: 'MAIN.LIKE_PHONE',
    icon: "phone",
    iconHome: "home-heart",
    title: 'Добавить объявление в избранное +\nпросмотр контактов',
    titleComment: 'клик по номеру',
    initialShare: 0.4,
    activityType: 'Контакты',
    price: CHAIN_ACTION_PRICE,
  },
  {
    type: 'MAIN.MESSAGE',
    icon: "message",
    iconHome: "home-message",
    title: 'Написать сообщение продавцу',
    initialShare: 0.1,
    activityType: 'Сообщение',
    price: CHAIN_ACTION_PRICE,
  },
  {
    type: 'MAIN.SUBSCRIBE',
    icon: "people",
    iconHome: "home-people",
    title: 'Подписаться на продавца',
    initialShare: 0.2,
    activityType: 'Подписка',
    price: CHAIN_ACTION_PRICE,
  },

  { type: 'ALWAYS.OPEN_AVITO', icon: "open", iconHome: "home-open", title: 'Открыть сайт или приложение', initialShare: 1.00 },
  { type: 'ALWAYS.SEARCH_PHRASE', icon: "search", iconHome: "home-search", title: 'Написать поисковый запрос', initialShare: 1.00 },
  { type: 'ALWAYS.SEE_COMPETITORS', icon: "time", iconHome: "home-time", title: 'Быстро просмотреть конкурентов', initialShare: 1.00 },
  { type: 'ALWAYS.FIND_ME', icon: "search", iconHome: "home-search", title: 'Найти профиль и объявление через поиск', initialShare: 1.00 },
  { type: "ALWAYS.CLICK", icon: "click", iconHome: "home-click", title: "Зайти на карточку объявления", initialShare: 1.0 },

  { type: 'EXTRA.SEE_MEDIA', icon: "eye", iconHome: "home-eye", title: 'Просмотреть все фото и видео на карточке', initialShare: 0.30 },
  { type: 'EXTRA.SEE_MAP', icon: "click", iconHome: "home-click", title: 'Нажать «Показать на карте»', initialShare: 0.20 },
  { type: 'EXTRA.READ_NEXT', icon: "click", iconHome: "home-click", title: 'Нажать «Читать далее»', initialShare: 0.15 },
  { type: 'EXTRA.READ_DESCRIPTION', icon: "glasses", iconHome: "home-glasses", title: 'Прочитать описание объявления', initialShare: 0.10 },
  { type: 'EXTRA.READ_FEEDBACKS', icon: "glasses", iconHome: "home-glasses", title: 'Прочитать отзывы на продавца', initialShare: 0.20 },
  { type: 'EXTRA.SEE_OTHER_ADS', icon: "click", iconHome: "home-click", title: 'Посмотреть другие объявления продавца', initialShare: 0.05 },

  {
    type: 'VIEW.MEDIA',
    icon: "eye",
    iconHome: "home-eye",
    title: 'Просмотр объявления от 30 сек +\nфото / видео',
    titleComment: 'Непрямая ссылка. Заход через браузер',
    initialShare: 1 / 3,
    price: 2,
    subactions: 2,
    itemTitle: 'сценарий',
    subactionsComment: VIEW_SUBACTIONS_COMMENT,
  },
  {
    type: 'VIEW.PHONE',
    icon: "eye",
    iconHome: "home-eye",
    title: 'Просмотр объявления от 30 сек +\nпрочитать описание',
    titleComment: 'Непрямая ссылка. Заход через браузер',
    initialShare: 1 / 3,
    price: 2,
    subactions: 2,
    itemTitle: 'сценарий',
    subactionsComment: VIEW_SUBACTIONS_COMMENT,
  },
  {
    type: 'VIEW.PHOTO',
    icon: "eye",
    iconHome: "home-eye",
    title: 'Просмотр объявления от 30 сек +\nпочитать отзывы',
    titleComment: 'Непрямая ссылка. Заход через браузер',
    initialShare: 1 / 3,
    price: 2,
    subactions: 2,
    itemTitle: 'сценарий',
    subactionsComment: VIEW_SUBACTIONS_COMMENT,
  },
];

const MAIN_PAGE_TITLES = [
  {
    iconHome: "home-action",
    title: "Изучение объявлений",
    titleComment: "Поведенческая активность",
    path: '/povedencheskie-faktory-na-obyavleniya',
    target: '_self',
    statusForHomePage: MARKET_MODE_STATUS.HIT,
  },
  {
    iconHome: "home-reviews",
    title: "Оставить отзыв",
    path: '/reviews-na-obyavleniya',
    target: '_self',
    statusForHomePage: MARKET_MODE_STATUS.POPULAR,
  },
  {
    iconHome: "home-eye",
    title: "Просмотреть объявление",
    path: '/views-na-obyavleniya',
    target: '_self',
  },
  {
    iconHome: "home-star",
    title: "Добавить в избранное",
    path: '/povedencheskie-faktory-na-obyavleniya',
    target: '_self',
  },
  {
    iconHome: "home-contacts",
    title: "Избранное + контакты",
    path: '/povedencheskie-faktory-na-obyavleniya',
    target: '_self',
  },
  {
    iconHome: "home-message",
    title: "Сообщение продавцу",
    path: '/povedencheskie-faktory-na-obyavleniya',
    target: '_self',
  },
  {
    iconHome: "home-people",
    title: "Подписка на продавца",
    path: '/povedencheskie-faktory-na-obyavleniya',
    target: '_self',
  },
  {
    iconHome: "home-open",
    title: "Переход по ссылке",
    path: '/povedencheskie-faktory-na-obyavleniya',
    target: '_self',
  },
  {
    iconHome: "home-magic",
    title: "Генерация отзыва от GPT",
    // titleComment: "не пишите сами — GPT сделает это за вас",
    path: 'https://ai.boostclick.ru/',
    target: '_blank',
    isGPT: true
  }
];

const LIST_ONLINE_SERVICES = [
  {
    title: "Своя услуга",
  },
  {
    title: "Диагностика ноутбука / ПК",
    text: "Тестировщик получает удаленную консультацию и диагностику",
  },
  {
    title: "Диагностика автомобиля",
    text: "Тестировщик получает удаленную консультацию и рекомендации",
  },
  {
    title: "Онлайн-консультация стилиста",
    text: "Тестировщик описывает свой стиль и  получает рекомендации",
  },
  {
    title: "Дизайн-проект одной комнаты / зоны",
    text: "Тестировщик предоставляет размеры, фотографии, получает эскиз расстановки мебели",
  },
  {
    title: "Подбор ухода за кожей / ароматов",
    text: "Тестировщик проходит онлайн-опрос и получает рекомендации",
  },
  {
    title: "Консультация по тренировкам / питанию",
    text: "Тестировщик описывает свои цели и получает базовые рекомендации",
  },
  {
    title: "Оценка стоимости ювелирных изделий по фото",
    text: "Тестировщик присылает фото и получает примерную оценку",
  },
  {
    title: "Онлайн-подбор тура (без бронирования)",
    text: "Тестировщик описывает пожелания и получает варианты туров",
  },
  {
    title: "Обработка одного фото / видео до 30s",
    text: "Тестировщик присылает исходник и получает обработанный вариант",
  },
  {
    title: "Расчет сметы на ремонт по предоставленным размерам",
    text: "Тестировщик присылает замеры помещения и получает расчет",
  },
  {
    title: "Другое (укажите свою услугу)",
  },
];

const STEP_PHRASE_2 = 'Укажите детали для поиска объявления';

const AVITO_KEYWORDS = [
  'Avito', 'avito', 'Авито', 'авито'
];

class AvitoClass extends Market {

  id = 'avito';
  host = 'avito.ru';
  url = 'https://www.avito.ru/';

  title = 'Авито*';

  isMarketplace = true;

  icon = "avito";
  titlePlaces = 'Авито*';
  statusForHomePage = MARKET_MODE_STATUS.POPULAR;
  mainPageTitles = MAIN_PAGE_TITLES;

  categories = [
    { type: 'Транспорт' },
    { type: 'Недвижимость' },
    { type: 'Работа' },
    { type: 'Услуги' },
    { type: 'Личные вещи' },
    { type: 'Для дома и дачи' },
    { type: 'Запчасти и аксессуары' },
    { type: 'Электроника' },
    { type: 'Хобби и отдых' },
    { type: 'Животные' },
    { type: 'Бизнес и оборудование' },
    { type: 'Молл' },
  ];

  chainsPerDayNormal = 200 / 30;

  chainPrice = 24;
  chainsMin = 4;
  chainsMax = 250;

  chainsDefault = 10;

  reviewPrice = REVIEW_PRICE;
  viewPrice = 4;
  viewsMax = 300;

  chainsStep = 1;
  viewsStep = 10;

  keywords = AVITO_KEYWORDS;

  targetLinkComment = <span>Укажите тут адрес вашего объявления <i>(не профиля)</i></span>;
  targetLinkCommentShort = <span>Укажите ссылку объявления <i>(не профиля)</i></span>;

  //статусы для главной страницы ПФ — хит; Отзывы — популярно
  modes = [
    {
      id: MARKET_MODES.CHAINS,
      path: '/povedencheskie-faktory-na-obyavleniya',
      rating: 0.99,
      title: 'ПФ',
      navigateTitle: 'ПФ действия и отклик на объявления',
      icon: "lightning",
      iconForHomePage: "home-action",
      status: MARKET_MODE_STATUS.REGULAR,
      statusForHomePage: MARKET_MODE_STATUS.HIT,
      meta: {
        title: 'Накрутка ПФ ЛЮДИ на объявления — от 1 руб. fdbnj | Boostclick',
        description: 'Купить накрутку ПФ ЛЮДИ на fdbnj от 1 руб. — просмотры, добавления, активность.',
        canonical: '/povedencheskie-faktory-na-obyavleniya',
      },
      intro: {
        title: 'Альтернатива «накрутки» ПФ для Авитологов',
        comment: 'Пользовательское тестирование и сценарии вовлечения',
        points: [
          'Поиск ↑: Анализ поведения в органическом поиске',
          'Интерес ↑: Изучение цепочек действий до контакта с продавцом',
          'CTR ↑: Проверка привлекательности заголовков и описаний',
          'Конверсия ↑: Сценарии выявляют точки выхода и интереса',
          'Честность ↑: Только реальные пользователи и подтвержденные действия',
        ]
      },
      hiddenContent: [
        'Купить ga fdbnj',
        'Накрутка ga fdbnj',
        'Заказать ПФ fdbnj'
      ],
      howItWorks: [
        /* 'Настройте параметры активности в соответствии с конкуренцией',
        'Укажите ссылку на объявление для скриншота',
        'Укажите категорию, город и ключевые фразы из объявления',
        'После оплаты мы передадим исполнителю скриншот и параметры для поиска',
        'Проверьте ответы и активность, примите работу или отправьте на доработку' */
      ],
      stepPhrase1: 'Создайте ПФ сценарий взаимодействия с объявлениями',
      stepPhrase2: STEP_PHRASE_2,
      stepTwoTitleFaq: STEP_TWO_TITLE_FAQ,
      calculatorTitle: 'Настройте сценарии ПФ для ваших объявлений',
      titleFAQ: "Вопрос-ответ по работе сервиса накрутки ПФ на досках объявлений",
      faq: CHAINS_FAQ,
      article: AVITO_PF_ARTICLE,
      actions: (() => {
        return [
          ...ACTIONS.filter(action => action.type !== 'MAIN.REVIEW' && !action.type.startsWith('VIEW.')),
          ...ACTIONS.filter(action => action.type === 'MAIN.REVIEW'),
        ];
      })(),
      notice: [
        '* Сервис сгенерирует уникальные цепочки действий с учетом поисковых запросов.',
        '** При написании отзывов исполнители полностью проходят путь пользователя от органического поиска до общения по товару / услуге с продавцом.',
        'Каждый исполнитель получит индивидуальное задание, что гарантирует разное поведение пользователей на вашем объявлении.',
        'В первую очередь будут выполняться действия связанные с органическим поиском и изучением объявления, далее добавление в избранное и подписки. В последнюю очередь делаются действия с чатом на досках объявлений.',
        'Сложность цепочек и время исполнения зависит от их количества в проекте.',
      ]
    },
    {
      id: MARKET_MODES.REVIEWS,
      path: '/reviews-na-obyavleniya',
      rating: 0.98,
      title: 'Отзывы',
      navigateTitle: 'Отзывы от пользователей на объявления',
      icon: "message",
      iconForHomePage: "home-reviews",
      status: MARKET_MODE_STATUS.REGULAR,
      statusForHomePage: MARKET_MODE_STATUS.POPULAR,
      meta: {
        title: `Купить отзывы на объявления от ${REVIEW_PRICE} руб. — накрутка fdbnj`,
        description: `Купить отзывы ЛЮДИ на досках объявлений от ${REVIEW_PRICE} руб. Реальные исполнители, отчеты, оплата по факту.`,
        canonical: '/reviews-na-obyavleniya',
      },
      intro: {
        title: `Получите обратную связь на досках объявлений`,
        comment: 'Через удаленное тестирование от реальных пользователей',
        points: [
          'Отзывы от настоящих людей после взаимодействия с вашим объявлением',
          'Тестирование услуги или предложения в реальных условиях',
          `Оплата только после выполнения задания и публикации отзыва (до ${WARRANTY_HOURS} часов)`,
          'Электронный чек после оплаты',
          'Подходит для любых сфер — B2C и B2B',
        ]
      },
      hiddenContent: [
        'Купить отзывы fdbnj',
        'Накрутка отзывов fdbnj',
        'Заказать отзывы yf fdbnj'
      ],
      howItWorks: [
        /* 'Настройте параметры активности в соответствии с конкуренцией',
        'Укажите ссылку на объявление для скриншота',
        'Укажите категорию, город и ключевые фразы из объявления',
        'После оплаты мы передадим исполнителю скриншот и параметры для поиска',
        'Проверьте ответы и активность, примите работу или отправьте на доработку' */
      ],
      stepPhrase1: 'Настройте параметры обратной связи на досках объявлений',
      stepPhrase2: STEP_PHRASE_2,
      stepTwoTitleFaq: STEP_TWO_TITLE_FAQ,
      calculatorTitle: 'Отзывы на объявления через тестирование от пользователей',
      titleFAQ: "Вопрос-ответ: отзывы на объявления через Boostclick",
      faq: REVIEWS_FAQ,
      listOnlineServices: LIST_ONLINE_SERVICES,
      actions: (() => {
        return [
          ...ACTIONS.filter(action => action.type === 'MAIN.REVIEW'),
          ...ACTIONS.filter(action => action.type !== 'MAIN.REVIEW' && !action.type.startsWith('VIEW.')),
        ];
      })(),
      notice: [
        '* Сервис сгенерирует уникальные цепочки действий с учетом поисковых запросов',
        'Сложность цепочек и время исполнения зависит от их количества в проекте',
        'Оплата — только после подтверждения результата',
        'Возможность бесплатной замены исполнителя при неудачном размещении',
        'Все отзывы основаны на личном опыте тестирования и не являются гарантированно положительными',
        'Платформа не размещает отзывы от своего имени и не вмешивается в содержание — только организует процесс',
      ]
    },
    {
      id: MARKET_MODES.VIEWS,
      path: '/views-na-obyavleniya',
      rating: 0.97,
      title: 'Просмотры',
      navigateTitle: 'Просмотры и поведение от пользователей на объявления',
      icon: "eye",
      iconForHomePage: "home-eye",
      status: MARKET_MODE_STATUS.REGULAR,
      meta: {
        title: `Просмотры на объявления от 1 руб. — накрутка fdbnj ЛЮДИ`,
        description: 'Накрутка просмотров ЛЮДИ на fdbnj от 1.9 руб. — просмотры, добавления, активность.',
        canonical: '/views-na-obyavleniya',
      },
      intro: {
        title: 'Анализ интереса через просмотры на досках объявлений',
        comment: 'Исследование объявлений через микрозадачи и UX-тестирование',
        points: [
          'A/B тестирование карточек с вовлечением пользователей',
          '↑ Реальные просмотры',
          '↑ Аналитика и гипотезы',
          '↑ Советы по улучшению',
          'Улучшайте содержание объявлений на основе ответов исполнителей',
        ]
      },
      hiddenContent: [
        'Купить просмотры fdbnj',
        'Накрутка просмотров fdbnj',
        'Заказать просмотры yf fdbnj'
      ],
      howItWorks: [
        'Разместите задание исполнителям',
        'Укажите ссылку на объявление',
        'Исполнители выполнят задания и ответят на контрольные вопросы',
        'Если задание выполнено верно, то примите его. Если нет, то смените исполнителя.'
      ],
      stepPhrase1: 'Настройте параметры заданий на просмотры',
      stepPhrase2: STEP_PHRASE_2,
      stepTwoTitleFaq: STEP_TWO_TITLE_FAQ,
      calculatorTitle: 'Разместить задание для тестирования объявления',
      titleFAQ: "Вопрос-ответ про накрутку просмотров на досках объявлений",
      faq: VIEWS_FAQ,
      actions: (() => {
        return [
          ...ACTIONS.filter(action => action.type.startsWith('VIEW.')),
        ];
      })(),
      notice: [
        '* Сервис сгенерирует уникальные цепочки действий с учетом поисковых запросов.',
        'Каждый исполнитель получит индивидуальное задание, что гарантирует разное поведение пользователей на вашем объявлении.',
        'Время исполнения зависит от количества задач в проекте.',
      ]
    },
  ];

  actionsMap = ACTIONS.reduce((map, action) => {
    map[action.type] = action; return map;
  }, {});

  emptyUrlStr = 'Укажите ссылку на объявление';
  invalidUrlStr = 'Укажите корректную ссылку на объявление';
}

const Avito = new AvitoClass();
export default Avito;
